import { render, staticRenderFns } from "./StartTransportation.vue?vue&type=template&id=fef1ec44&scoped=true&lang=true&"
import script from "./StartTransportation.vue?vue&type=script&lang=js&"
export * from "./StartTransportation.vue?vue&type=script&lang=js&"
import style0 from "./StartTransportation.vue?vue&type=style&index=0&id=fef1ec44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef1ec44",
  null
  
)

export default component.exports